import { Component } from '@angular/core';
import { HeaderComponent } from "../../layout/header/header.component";
import { FooterComponent } from "../../layout/footer/footer.component";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-life-events',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, RouterLink],
  templateUrl: './life-events.component.html',
  styleUrl: './life-events.component.scss'
})
export class LifeEventsComponent {

  email: string = 'adt@sprucepower.com';

  // Method to scroll to the target section
  scrollToSection(position:string): void {
    const element = document.getElementById(position);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

}
